import i18next from 'i18next'

export const getDecimalSeparatorFromLocale = (
  locale = i18next.language?.split('_')?.[0]
) => {
  return Intl.NumberFormat(locale)
    ?.format(1.1)
    ?.replace(/\p{Number}/gu, '')
}

export const getThousandsSeparatorFromLocale = (
  locale = i18next.language?.split('_')?.[0]
) => {
  return Intl.NumberFormat(locale)
    ?.format(11111)
    ?.replace(/\p{Number}/gu, '')
}

export const getNumberFromLocale = (num, locale = i18next.language?.split('_')?.[0]) => {
  const decimalSeparator = getDecimalSeparatorFromLocale(locale)
  const thousandSeparator = getThousandsSeparatorFromLocale(locale)
  // return +num
  //   ?.replace(new RegExp(`[^${decimalSign}\\d]`, 'g'), '')
  //   ?.replace(decimalSign, '.')
  let tempNum = num
  if (typeof tempNum === 'number') {
    tempNum = String(tempNum)
  }
  return +tempNum
    ?.replace?.(new RegExp('\\' + thousandSeparator, 'g'), '')
    ?.replace?.(new RegExp('\\' + decimalSeparator), '.')
}
